import GiBroom from '@meronex/icons/gi/GiBroom';
import EnPrint from '@meronex/icons/en/EnPrint';
import BiExitFullscreen from '@meronex/icons/bi/BiExitFullscreen';
import BiFullscreen from '@meronex/icons/bi/BiFullscreen';
import BisDownArrow from '@meronex/icons/bi/BisDownArrow';
import BisHome from '@meronex/icons/bi/BisHome';
import BisLeftArrow from '@meronex/icons/bi/BisLeftArrow';
import BisRightArrow from '@meronex/icons/bi/BisRightArrow';
import BisUpArrow from '@meronex/icons/bi/BisUpArrow';
import BisUserCircle from '@meronex/icons/bi/BisUserCircle';
import FaBars from '@meronex/icons/fa/FaBars';
import FaDownload from '@meronex/icons/fa/FaDownload';
import FaEdit from '@meronex/icons/fa/FaEdit';
import FaFile from '@meronex/icons/fa/FaFile';
import FaFilter from '@meronex/icons/fa/FaFilter';
import FaFolder from '@meronex/icons/fa/FaFolder';
import FaFolderOpen from '@meronex/icons/fa/FaFolderOpen';
import FaInfoCircle from '@meronex/icons/fa/FaInfoCircle';
import FaMinus from '@meronex/icons/fa/FaMinus';
import FaMinusSquare from '@meronex/icons/fa/FaMinusSquare';
import FaPlus from '@meronex/icons/fa/FaPlus';
import FaPlusSquare from '@meronex/icons/fa/FaPlusSquare';
import FaQuestionCircle from '@meronex/icons/fa/FaQuestionCircle';
import FaSave from '@meronex/icons/fa/FaSave';
import FaSquare from '@meronex/icons/fa/FaSquare';
import FaStar from '@meronex/icons/fa/FaStar';
import FaTrash from '@meronex/icons/fa/FaTrash';
import FaFastBackward from '@meronex/icons/fa/FaFastBackward';
import FaFastForward from '@meronex/icons/fa/FaFastForward';
import FaStepBackward from '@meronex/icons/fa/FaStepBackward';
import FaStepForward from '@meronex/icons/fa/FaStepForward';
import FdAlert from '@meronex/icons/fd/FdAlert';
import FiSquare from '@meronex/icons/fi/FiSquare';
import HiOutlineTranslate from '@meronex/icons/hi/HiOutlineTranslate';
import MdcCheckBold from '@meronex/icons/mdc/MdcCheckBold';
import MdcCloseThick from '@meronex/icons/mdc/MdcCloseThick';
import MdcFilterRemove from '@meronex/icons/mdc/MdcFilterRemove';
import MdcFormatLetterEndsWith from '@meronex/icons/mdc/MdcFormatLetterEndsWith';
import MdcRefresh from '@meronex/icons/mdc/MdcRefresh';
import RiGroupFill from '@meronex/icons/ri/RiGroupFill';
import RiUser3Fill from '@meronex/icons/ri/RiUser3Fill';
import AiOutlineDrag from '@meronex/icons/ai/AiOutlineDrag';
import { IconType } from '@meronex/icons';
import FaCalendarAlt from '@meronex/icons/fa/FaCalendarAlt';
import GoSearch from '@meronex/icons/go/GoSearch';
import FcSettings from '@meronex/icons/fc/FcSettings';
import FaLock from '@meronex/icons/fa/FaLock';
import AiOutlineEllipsis from '@meronex/icons/ai/AiOutlineEllipsis';
import FaVolumeUp from '@meronex/icons/fa/FaVolumeUp';
import AiOutlineComment from '@meronex/icons/ai/AiOutlineComment';
import EnFlowTree from '@meronex/icons/en/EnFlowTree';
import AiOutlineClockCircle from '@meronex/icons/ai/AiOutlineClockCircle';
import BiCube from '@meronex/icons/bi/BiCube';
import BsDot from '@meronex/icons/bs/BsDot';
import GoPrimitiveDot from '@meronex/icons/go/GoPrimitiveDot';
import BsFillCircleFill from '@meronex/icons/bs/BsFillCircleFill';
import MdKeyboardArrowUp from '@meronex/icons/md/MdKeyboardArrowUp';
import MdKeyboardArrowDown from '@meronex/icons/md/MdKeyboardArrowDown';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from '@meronex/icons/md/';
import FaRegPlusSquare from '@meronex/icons/fa/FaRegPlusSquare';
import FaRegMinusSquare from '@meronex/icons/fa/FaRegMinusSquare';
import FaUpload from '@meronex/icons/fa/FaUpload';
import MdcWeatherCloudyArrowRight from '@meronex/icons/mdc/MdcWeatherCloudyArrowRight';
import FaMicrophone from '@meronex/icons/fa/FaMicrophone';
import FaStop from '@meronex/icons/fa/FaStop';
import FaUndo from '@meronex/icons/fa/FaUndo';
import FaRedo from '@meronex/icons/fa/FaRedo';
import CgUndo from '@meronex/icons/cg/CgUndo';
import CgRedo from '@meronex/icons/cg/CgRedo';
import MdWork from '@meronex/icons/md/MdWork';
import GrSort from '@meronex/icons/gr/GrSort';
import BiWindows from '@meronex/icons/bi/BiWindows';
import BiWindow from '@meronex/icons/bi/BiWindow';
import FaStickyNote from '@meronex/icons/fa/FaStickyNote';
import AiOutlinePlus from '@meronex/icons/ai/AiOutlinePlus';
import EiClose from '@meronex/icons/ei/EiClose';
import FaExternalLinkAlt from '@meronex/icons/fa/FaExternalLinkAlt';
import FaCopy from '@meronex/icons/fa/FaCopy';
import BisMagicWand from '@meronex/icons/bi/BisMagicWand';
import FaFolderPlus from '@meronex/icons/fa/FaFolderPlus';
import MdcSigma from '@meronex/icons/mdc/MdcSigma';
import BsListTask from '@meronex/icons/bs/BsListTask';
import MdcLightbulbOnOutline from '@meronex/icons/mdc/MdcLightbulbOnOutline';
import SiMoleculer from '@meronex/icons/si/SiMoleculer';
import AiOutlineMergeCells from '@meronex/icons/ai/AiOutlineMergeCells';
import FaRegHandPaper from '@meronex/icons/fa/FaRegHandPaper';
import MdcSelectDrag from '@meronex/icons/mdc/MdcSelectDrag';
import BiZoomIn from '@meronex/icons/bi/BiZoomIn';
import BiZoomOut from '@meronex/icons/bi/BiZoomOut';
import MdcVectorDifference from '@meronex/icons/mdc/MdcVectorDifference';
import FaRegHandPointer from '@meronex/icons/fa/FaRegHandPointer';
import MdcLaptopWindows from '@meronex/icons/mdc/MdcLaptopWindows';
import MdcViewDashboard from '@meronex/icons/mdc/MdcViewDashboard';
import FaThumbtack from '@meronex/icons/fa/FaThumbtack';
import ImAttachment from '@meronex/icons/im/ImAttachment';
import MdcPenOff from '@meronex/icons/mdc/MdcPenOff';
import BiCamera from '@meronex/icons/bi/BiCamera';
import BiEraser from '@meronex/icons/bi/BiEraser';

export type TIconType = IconType;
export type TIconName = keyof typeof IconsMap;

/**
 * La idea original al menos, es que los nombres de los íconos sean lo más
 * genérico posible. Como ejemplo, tenemos el ícono Plus, cuyo nombre no indica
 * nada acerca del rol que ocupa en la aplicación, sino que solamente describe
 * qué ícono podemos esperar encontrar.
 *
 * Para indicar qué uso podría tener en la aplicación, se pueden agregar tags
 * en el array tags correspondiente.
 */
export const IconsMap = {
  Alert: { icon: FdAlert, tags: ['warning'] },
  AreaSelect: { icon: MdcSelectDrag, tags: [] },
  ArrowLeft: { icon: BisLeftArrow, tags: [] },
  ArrowRight: { icon: BisRightArrow, tags: [] },
  ArrowUp: { icon: BisUpArrow, tags: [] },
  ArrowDown: { icon: BisDownArrow, tags: [] },
  ArrowRightThin: { icon: MdKeyboardArrowRight, tags: [] },
  ArrowLeftThin: { icon: MdKeyboardArrowLeft, tags: [] },
  ArrowUpThin: { icon: MdKeyboardArrowUp, tags: [] },
  ArrowDownThin: { icon: MdKeyboardArrowDown, tags: [] },
  Attach: { icon: ImAttachment, tags: ['doc'] },
  Broom: { icon: GiBroom, tags: ['clean'] },
  Bulb: { icon: MdcLightbulbOnOutline, tags: ['idea', 'suggest'] },
  Camera: { icon: BiCamera, tags: ['camera'] },
  Calendar: { icon: FaCalendarAlt, tags: ['date'] },
  Check: { icon: MdcCheckBold, tags: ['ok', 'success'] },
  CircleFilled: { icon: BsFillCircleFill, tags: [] },
  Clock: { icon: AiOutlineClockCircle, tags: [] },
  CloudArrow: { icon: MdcWeatherCloudyArrowRight, tags: ['apply'] },
  Close: { icon: MdcCloseThick, tags: ['delete', 'erase', 'cross', 'error'] },
  CloseThin: { icon: EiClose, tags: ['delete', 'erase', 'cross', 'error'] },
  Comment: { icon: AiOutlineComment, tags: [] },
  Copy: { icon: FaCopy, tags: [] },
  CrossFilter: { icon: MdcFilterRemove, tags: [] },
  Cube: { icon: BiCube, tags: [] },
  Desktop: { icon: MdcViewDashboard, tags: ['desktop'] },
  Difference: { icon: MdcVectorDifference, tags: [] },
  Download: { icon: FaDownload, tags: [] },
  DotSmall: { icon: BsDot, tags: [] },
  DotBig: { icon: GoPrimitiveDot, tags: [] },
  DragAndDrop: { icon: AiOutlineDrag, tags: ['drag', 'drop', 'dnd'] },
  Edit: { icon: FaEdit, tags: ['pen'] },
  Ellipsis: { icon: AiOutlineEllipsis, tags: ['context', 'menu', 'details'] },
  External: { icon: FaExternalLinkAlt, tags: ['ref', 'open'] },
  Erase: { icon: BiEraser, tags: ['eraser'] },
  File: { icon: FaFile, tags: ['document'] },
  Filter: { icon: FaFilter, tags: [] },
  First: { icon: FaFastBackward, tags: [] },
  FlowTree: { icon: EnFlowTree, tags: [] },
  FolderClosed: { icon: FaFolder, tags: ['directory'] },
  FolderOpen: { icon: FaFolderOpen, tags: ['directory'] },
  FolderPlus: { icon: FaFolderPlus, tags: ['add'] },
  Groups: { icon: RiGroupFill, tags: [] },
  Hamburguer: { icon: FaBars, tags: ['menu'] },
  Help: { icon: FaQuestionCircle, tags: ['question'] },
  Home: { icon: BisHome, tags: ['house'] },
  Info: { icon: FaInfoCircle, tags: [] },
  Laptop: { icon: MdcLaptopWindows, tags: [] },
  Last: { icon: FaFastForward, tags: [] },
  LetterAutocomplete: { icon: MdcFormatLetterEndsWith, tags: [] },
  Locked: { icon: FaLock, tags: ['secure'] },
  Magic: { icon: BisMagicWand, tags: ['generate'] },
  Maximize: { icon: BiFullscreen, tags: ['fullscreen'] },
  Merge: { icon: AiOutlineMergeCells, tags: [] },
  Microphone: { icon: FaMicrophone, tags: ['record'] },
  Minimize: { icon: BiExitFullscreen, tags: ['fullscreen'] },
  Minus: { icon: FaMinus, tags: ['collapse', 'hide'] },
  MinusReverse: { icon: FaRegMinusSquare, tags: ['collapse', 'hide'] },
  MinusFilled: { icon: FaMinusSquare, tags: ['collapse', 'hide'] },
  Molecule: { icon: SiMoleculer, tags: ['redistribute', 'distribution'] },
  Next: { icon: FaStepForward, tags: [] },
  Note: { icon: FaStickyNote, tags: [] },
  PanHand: { icon: FaRegHandPaper, tags: ['Pan'] },
  Pin: { icon: FaThumbtack, tags: [] },
  Plus: { icon: FaPlus, tags: ['additional', 'expand', 'show'] },
  PlusReverse: {
    icon: FaRegPlusSquare,
    tags: ['additional', 'expand', 'show'],
  },
  PlusFilled: { icon: FaPlusSquare, tags: ['additional', 'expand', 'show'] },
  PlusThin: { icon: AiOutlinePlus, tags: [] },
  Pointer: { icon: FaRegHandPointer, tags: ['hand', 'point'] },
  Previous: { icon: FaStepBackward, tags: [] },
  Print: { icon: EnPrint, tags: [] },
  Redo: { icon: FaRedo, tags: [] },
  RedoSmall: { icon: CgRedo, tags: [] },
  Readonly: { icon: MdcPenOff, tags: [] },
  Refresh: { icon: MdcRefresh, tags: ['reload'] },
  Save: { icon: FaSave, tags: [] },
  Search: { icon: GoSearch, tags: [] },
  Settings: { icon: FcSettings, tags: ['configuration'] },
  SquareFilled: { icon: FaSquare, tags: [] },
  SquareOutline: { icon: FiSquare, tags: [] },
  Sort: { icon: GrSort, tags: [] },
  Star: { icon: FaStar, tags: ['favorite'] },
  Stop: { icon: FaStop, tags: [] },
  Sum: { icon: MdcSigma, tags: ['math', 'total'] },
  TaskList: { icon: BsListTask, tags: ['list', 'todo'] },
  Translate: { icon: HiOutlineTranslate, tags: ['language'] },
  Trash: { icon: FaTrash, tags: ['delete', 'erase'] },
  Undo: { icon: FaUndo, tags: ['back'] },
  UndoSmall: { icon: CgUndo, tags: ['back'] },
  Upload: { icon: FaUpload, tags: [] },
  User: { icon: BisUserCircle, tags: [] },
  User2: { icon: RiUser3Fill, tags: [] },
  Volume: { icon: FaVolumeUp, tags: [] },
  WindowMaximize: { icon: BiWindow, tags: [] },
  WindowMinimize: { icon: BiWindows, tags: [] },
  Work: { icon: MdWork, tags: [] },
  ZoomIn: { icon: BiZoomIn, tags: ['zoom'] },
  ZoomOut: { icon: BiZoomOut, tags: ['zoom'] },
};
export const icons = new Proxy(
  {},
  {
    get(_, prop): TIconType {
      return IconsMap[prop as keyof typeof IconsMap].icon;
    },
  },
) as unknown as Record<keyof typeof IconsMap, TIconType>;

/**
 * Se puede utilizar este type guard para aceptar argumentos en los componentes
 * que permitan pasar tanto un nombre de ícono como un ícono en sí.
 *
 * @example
 *-
 * ({icon}: {icon: TIconName | TIconType}) => {
 *   const ActualIcon = React.useMemo(
 *     ()=> isIconName(icon) ? (() => <Icon name={icon} />) : icon
 *   , [])
 *   return <ActualIcon />
 * }
 */
export function isIconName(arg: TIconName | TIconType): arg is TIconName {
  return typeof arg === 'string' && arg in IconsMap;
}
